"use client";

import type { HTMLAttributes } from "react";

import { cn } from "../../utils";

export type DialogBodyProps = HTMLAttributes<HTMLDivElement> & {
  isLoading?: boolean;
};

/**
 * `overflow-auto` makes this a clipping box whether or not it actually scrolls, so a control flush
 * against its edge would lose its focus ring. The `py-1` keeps 4px inside the padding box — the
 * spread every focus shadow in the preset uses (`shadow-input`, `shadow-button-*`, …) — so the last
 * row of a body can still draw one. Call sites that set their own vertical padding override it.
 */
const Body = ({ className, children, ...props }: DialogBodyProps) => {
  return (
    <div data-dialog-body="" className={cn("overflow-auto px-6 py-1", className)} {...props}>
      {children}
    </div>
  );
};

Body.displayName = "Body";

export default Body;
